// import Raven from 'raven-js';

import i18n from "@/plugins/i18n";
import toast from "@/plugins/toast";

import Firebase from "@/services/Firebase";

export default {
  namespaced: true,
  state: {
    isLoggedIn: false,
    requestInProcess: false,
    errorMessage: "",
    userData: null,
  },
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    displayName: (state, getters, rootState) => {
      if (rootState["settings/incognitoMode"]) return "Incognito";
      if (state.isLoggedIn)
        return state.userData.user.displayName || state.userData.user.email;
      return i18n.t("user_menu.not_logged");
    },
    photoUrl: (state, getters) => {
      return state.isLoggedIn ? state.userData.user.photoURL : "";
    },
    userId: (state) => {
      return state.isLoggedIn ? state.userData.user.uid : null;
    },
    userEmail: (state) => {
      return state.isLoggedIn ? state.userData.user.email : null;
    },
  },
  mutations: {
    setIsLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setUserData(state, userData) {
      state.userData = userData;
    },
    setRequestInProcess(state, requestInProcess) {
      state.requestInProcess = requestInProcess;
    },
    setErrorMessage(state, errorMessage) {
      state.errorMessage = errorMessage.message;
      state.errorKey = errorMessage.code;
    },
  },
  actions: {
    async register({ commit, dispatch }, { email, password }) {
      commit("setRequestInProcess", true);
      commit("setErrorMessage", "");
      try {
        await Firebase.register(email, password);
        toast({
          message: i18n.t("notifications.sign_in"),
          type: "success",
          timeout: 3000,
        });
      } catch (error) {
        commit("setErrorMessage", error);
        // Raven.captureMessage(error.code, { extra: error });
        return Promise.reject("Register Request Failed", error);
      } finally {
        commit("setRequestInProcess", false);
      }
      return Promise.resolve();
    },
    async login({ commit, dispatch }, { email, password, type }) {
      commit("setRequestInProcess", true);
      commit("setErrorMessage", "");
      try {
        await Firebase.login(type)(email, password);
        toast({
          message: i18n.t("notifications.sign_in"),
          type: "success",
          timeout: 3000,
        });
      } catch (error) {
        commit("setErrorMessage", error);
        // Raven.captureMessage(error.code, { extra: error });
        return Promise.reject("Login Request Failed", error);
      } finally {
        commit("setRequestInProcess", false);
      }
      return Promise.resolve();
    },
    async logout({ commit, dispatch }) {
      toast({
        message: i18n.t("notifications.sign_out"),
        type: "info",
        timeout: 3000,
      });
      Firebase.signOut().then(() => {
        commit("setIsLoggedIn", false);
        // dispatch("exchange/logout", undefined, { root: true });
        dispatch("portfolio/setDefaultAssets", undefined, { root: true });
        dispatch("profitloss/setDefaultValues", undefined, { root: true });
      });
    },
    async resetPassword({ commit }, { email }) {
      commit("setRequestInProcess", true);
      commit("setErrorMessage", "");
      try {
        await Firebase.resetPassword(email);
      } catch (error) {
        commit("setErrorMessage", error);
        // Raven.captureMessage(error.code, { extra: error });
        return Promise.reject("resetPassword Failed", error);
      } finally {
        commit("setRequestInProcess", false);
      }
      return Promise.resolve();
    },
    /*
    exchangeAuth({ getters, dispatch, rootGetters }) {
      if (!rootGetters["exchange/isLoggedIn"]) {
        Firebase.getIdToken()
          .then(function(idToken) {
            dispatch(
              "exchange/loginFirebase",
              {
                firebaseEmail: getters.userEmail,
                firebaseIdToken: idToken,
              },
              { root: true }
            );
          })
          .catch(function(error) {
            console.error(error);
            toast({
              message: "Firebase getIdToken error..",
              type: "error",
              timeout: 2000,
            });
          });
      } else {
        dispatch("exchange/fetchAllExchangeData", undefined, { root: true });
      }
    },
    */
    onUpdateAuth({ commit, dispatch, rootGetters }, userData) {
      commit("setUserData", userData);
      // Raven.setUserContext({ uid: user.uid });

      // dispatch("exchangeAuth");

      commit("setIsLoggedIn", true);
    },
    onRemoveAuth({ commit, dispatch }) {
      // Raven.setUserContext();
      commit("setIsLoggedIn", false);
      // dispatch("exchange/logout", undefined, { root: true });
    },
  },
};
